import { refLanguage } from "@tc/drizzle-v2"
import { eq, and } from "drizzle-orm"
import {
  SQSClient,
  SendMessageCommand,
  MessageAttributeValue,
} from "@aws-sdk/client-sqs"
import { DbTransaction } from "@tc/middy-decorators"
import { LanguageDoc } from "../types/reference-data"
import { searchBuilderLog } from "../utils/logger"

const sqs_client = new SQSClient({})
const queue_url = process.env["LANGUAGE_QUEUE_URL"]

export const getLanguageData = async (
  tx: DbTransaction,
  id: string,
): Promise<LanguageDoc | undefined> => {
  const language_id = Number(id)
  const [row] = await tx
    .select({
      id: refLanguage.id,
      itemCode: refLanguage.itemCode,
      itemName: refLanguage.itemName,
      rightToLeft: refLanguage.rightToLeft,
      active: refLanguage.active,
      updatedAt: refLanguage.updatedAt,
      updatedBy: refLanguage.updatedBy,
    })
    .from(refLanguage)
    .where(and(eq(refLanguage.id, language_id), eq(refLanguage.active, true)))

  if (!row) {
    console.error(`Language with id ${id} not found/active`)
    return
  }

  const languageDoc: LanguageDoc = {
    id: row.id.toString(),
    language_code: row.itemCode,
    language_name: row.itemName,
    right_to_left: row.rightToLeft,
    active: row.active,
    updated_at: row.updatedAt.getTime(),
    updated_by: row.updatedBy,
  }

  searchBuilderLog.debug({
    document: languageDoc,
  })

  return languageDoc
}

export const saveLanguageToSearch = async (
  tx: DbTransaction,
  id: string,
  collectionName: string,
  options?: { returnDoc?: boolean },
): Promise<void> => {
  const doc = await getLanguageData(tx, id)

  if (!doc || Object.keys(doc).length === 0) {
    console.error(`Failed to prepare document for id: ${id}`)
    return
  }

  if (options?.returnDoc) return doc as never

  const attributes: Record<string, MessageAttributeValue> = {
    collection: {
      StringValue: collectionName,
      DataType: "String",
    },
  }

  const command = new SendMessageCommand({
    QueueUrl: queue_url,
    MessageBody: JSON.stringify(doc),
    MessageAttributes: attributes,
  })

  await sqs_client.send(command)
}
